import { ButtonBase, Stack, Typography } from "@mui/material";
import { ArrowRightIcon } from "@phosphor-icons/react";
import FlexBox from "../../components/layouts/Flexbox";
import { APP_COLORS, ENUM_USER_ROLE } from "../../enums";

type TimesHistorySectionProps = {
  viewerRole?: ENUM_USER_ROLE;
  onViewHistory: () => void;
};

export function TimesHistorySection({
  viewerRole,
  onViewHistory,
}: TimesHistorySectionProps) {
  const counterparty =
    viewerRole === ENUM_USER_ROLE.AMBASSADOR ? "vendor" : "ambassador";

  return (
    <ButtonBase
      onClick={onViewHistory}
      sx={{
        width: "100%",
        textAlign: "left",
        borderRadius: 1,
        display: "block",
        p: 0,
        "&:hover": {
          backgroundColor: "action.hover",
        },
      }}
    >
      <Stack gap={0.25} alignItems="flex-start">
        <FlexBox alignItems="center" gap={0.5}>
          <Typography variant="body-helveticaNeue-medium" fontSize={14}>
            Times history
          </Typography>
          <ArrowRightIcon size={18} color={APP_COLORS.primary} />
        </FlexBox>
        <Typography
          variant="caption"
          color="text.secondary"
          lineHeight={1.35}
          fontSize={10}
        >
          View the complete history of all times submissions and suggestions
          exchanged between you and the {counterparty}.
        </Typography>
      </Stack>
    </ButtonBase>
  );
}
